import { isUrl } from "@zickko/shared";
import { TextInputProps } from "../elements/TextInput";
import { FormItemProps } from "./FormItemContainer";
import { FormTextInput } from "./FormTextInput";

type Props = TextInputProps & FormItemProps<string>;

export const FormUrlInput = (props: Props) => {
  return (
    <>
      <FormTextInput {...props} />
      {isUrl(props.value) && (
        <div className="url-preview" style={{ marginTop: "-10px" }}>
          <span>Preview: </span>
          <a href={props.value} target="_blank">
            {props.value}
          </a>
        </div>
      )}
    </>
  );
};
